export const GENERAL_TAB_TITLE = "activation.settings.title";
export const SUBSCRIPTIONS_TAB_TITLE = "activation.settings.subscriptions.tab.title";
export const NEWS_SETTINGS_TAB_TITLE = "activation.settings.news.tab.title";
export const COMPETITORS_AFFECT_BENCHMARK = "activation.settings.section.competitors.subtitle";
export const CURRENT_CRUMB = "activation.settings.text";
